import { render, staticRenderFns } from "./tableprojectlist.vue?vue&type=template&id=21cedb9c"
import script from "./tableprojectlist.vue?vue&type=script&lang=js"
export * from "./tableprojectlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports